<template>
  <span class="hb-indicators">
    <span
      v-for="x in indicators"
      :key="x.title"
      :title="x.title"
      :class="x.color"
    />
  </span>
</template>

<script>
import _ from 'lodash'

function hasGps(hb) {
  let flag = _.get(hb, 'summary.hasGps')
  if (flag == false) return false

  if (
    hb.latitude == 0 ||
    hb.longitude == 0 ||
    hb.latitude >= 90 ||
    hb.latitude <= -90 ||
    hb.longitude <= -180 ||
    hb.longitude >= 180
  ) {
    return false
  }

  return true
}

export default {
  props: {
    heartbeat: { type: Object, required: true }
  },
  computed: {
    indicators() {
      let h = this.heartbeat.summary
      let result = [
        ['engineOn', 'blue', h.engineOn],
        ['hasSpeed', 'amber', h.hasSpeed],
        ['noGps', 'red', !hasGps(this.heartbeat)],
        ['speedFromGps', 'grey', h.speedFromGps],
        ['rpmFromAccel', 'purple', h.rpmFromAccel],
        ['dumpPointer', 'red', h.hasDumpedPointer],
        ['ptrCorrection', 'red', h.hasPointerCorrection],
        ['skipped', 'black', h.skipped],
        ['wifiId', 'green', _.get(h, 'variables.wifiId') != null],
        ['globalstar', 'pink', this.heartbeat.source == 0x01],
        ['shutdown', 'red', _.get(h, 'variables.shutdownReason') != null],
        ['drainedOut', 'green', h.drainedOut]
      ].map((i) => {
        let title = i[0]
        let color = i[2] ? i[1] : ''
        return { title, color }
      })

      return result
    }
  }
}
</script>

<style lang="sass">
.hb-indicators
  display: flex
  flex-flow: row nowrap

.hb-indicators > *
  background-color: #ccc
  height: 18px
  width: 6px
  border-radius: 1px
  margin: 0 1px


/* usado no unpauser */
.hb-indicators.large > *
  width: auto
  padding: 0 5px
  border-radius: 4px
  background-color: #ddd
  color: #fff

.hb-indicators.large > .on
  background-color: #4caf50
  /* color: black */
</style>
